/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Attachment,
  AttachmentRequest,
  AttachmentUploadRequestRequest,
  AttachmentsListParams,
  PaginatedAttachmentList
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAttachmentsListUrl = (params?: AttachmentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/attachments/?${stringifiedParams}` : `/api/attachments/`
}

export const attachmentsList = async (params?: AttachmentsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedAttachmentList> => {

  return customFetch<PaginatedAttachmentList>(getAttachmentsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAttachmentsListInfiniteQueryKey = (params?: AttachmentsListParams,) => {
    return [
    'infinite', `/api/attachments/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAttachmentsListQueryKey = (params?: AttachmentsListParams,) => {
    return [
    `/api/attachments/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAttachmentsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof attachmentsList>>, AttachmentsListParams['page']>, TError = void>(params?: AttachmentsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof attachmentsList>>, TError, TData, QueryKey, AttachmentsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAttachmentsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof attachmentsList>>, QueryKey, AttachmentsListParams['page']> = ({ signal, pageParam }) => attachmentsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof attachmentsList>>, TError, TData, QueryKey, AttachmentsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AttachmentsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof attachmentsList>>>
export type AttachmentsListInfiniteQueryError = void


export function useAttachmentsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof attachmentsList>>, AttachmentsListParams['page']>, TError = void>(
 params: undefined |  AttachmentsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof attachmentsList>>, TError, TData, QueryKey, AttachmentsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof attachmentsList>>,
          TError,
          Awaited<ReturnType<typeof attachmentsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAttachmentsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof attachmentsList>>, AttachmentsListParams['page']>, TError = void>(
 params?: AttachmentsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof attachmentsList>>, TError, TData, QueryKey, AttachmentsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof attachmentsList>>,
          TError,
          Awaited<ReturnType<typeof attachmentsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAttachmentsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof attachmentsList>>, AttachmentsListParams['page']>, TError = void>(
 params?: AttachmentsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof attachmentsList>>, TError, TData, QueryKey, AttachmentsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAttachmentsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof attachmentsList>>, AttachmentsListParams['page']>, TError = void>(
 params?: AttachmentsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof attachmentsList>>, TError, TData, QueryKey, AttachmentsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAttachmentsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAttachmentsListQueryOptions = <TData = Awaited<ReturnType<typeof attachmentsList>>, TError = void>(params?: AttachmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attachmentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAttachmentsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof attachmentsList>>> = ({ signal }) => attachmentsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof attachmentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AttachmentsListQueryResult = NonNullable<Awaited<ReturnType<typeof attachmentsList>>>
export type AttachmentsListQueryError = void


export function useAttachmentsList<TData = Awaited<ReturnType<typeof attachmentsList>>, TError = void>(
 params: undefined |  AttachmentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof attachmentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof attachmentsList>>,
          TError,
          Awaited<ReturnType<typeof attachmentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAttachmentsList<TData = Awaited<ReturnType<typeof attachmentsList>>, TError = void>(
 params?: AttachmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attachmentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof attachmentsList>>,
          TError,
          Awaited<ReturnType<typeof attachmentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAttachmentsList<TData = Awaited<ReturnType<typeof attachmentsList>>, TError = void>(
 params?: AttachmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attachmentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAttachmentsList<TData = Awaited<ReturnType<typeof attachmentsList>>, TError = void>(
 params?: AttachmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attachmentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAttachmentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAttachmentsCreateUrl = () => {




  return `/api/attachments/`
}

export const attachmentsCreate = async (attachmentRequest: AttachmentRequest, options?: Parameters<typeof customFetch>[1]): Promise<Attachment> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Attachment>(getAttachmentsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(attachmentRequest)
  }
);}





export const getAttachmentsCreateMutationKey = () => ['attachmentsCreate'] as const;

export const getAttachmentsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachmentsCreate>>, TError,AttachmentsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof attachmentsCreate>>, TError,AttachmentsCreateMutationVariables, TContext> => {

const mutationKey = getAttachmentsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof attachmentsCreate>>, AttachmentsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  attachmentsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AttachmentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof attachmentsCreate>>>
    export type AttachmentsCreateMutationBody = AttachmentRequest
    export type AttachmentsCreateMutationError = void
    export type AttachmentsCreateMutationVariables = {data: AttachmentRequest}

    export const useAttachmentsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachmentsCreate>>, TError,AttachmentsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof attachmentsCreate>>,
        TError,
        AttachmentsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAttachmentsCreateMutationOptions(options), queryClient);
    }
    export const getAttachmentsRetrieveUrl = (id: string,) => {




  return `/api/attachments/${id}/`
}

export const attachmentsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<Attachment> => {

  return customFetch<Attachment>(getAttachmentsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAttachmentsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/attachments/${id}/`
    ] as const;
    }


export const getAttachmentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof attachmentsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attachmentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAttachmentsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof attachmentsRetrieve>>> = ({ signal }) => attachmentsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof attachmentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AttachmentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof attachmentsRetrieve>>>
export type AttachmentsRetrieveQueryError = void


export function useAttachmentsRetrieve<TData = Awaited<ReturnType<typeof attachmentsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof attachmentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof attachmentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof attachmentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAttachmentsRetrieve<TData = Awaited<ReturnType<typeof attachmentsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attachmentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof attachmentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof attachmentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAttachmentsRetrieve<TData = Awaited<ReturnType<typeof attachmentsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attachmentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAttachmentsRetrieve<TData = Awaited<ReturnType<typeof attachmentsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof attachmentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAttachmentsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAttachmentsDestroyUrl = (id: string,) => {




  return `/api/attachments/${id}/`
}

export const attachmentsDestroy = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getAttachmentsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAttachmentsDestroyMutationKey = () => ['attachmentsDestroy'] as const;

export const getAttachmentsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachmentsDestroy>>, TError,AttachmentsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof attachmentsDestroy>>, TError,AttachmentsDestroyMutationVariables, TContext> => {

const mutationKey = getAttachmentsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof attachmentsDestroy>>, AttachmentsDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  attachmentsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AttachmentsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof attachmentsDestroy>>>

    export type AttachmentsDestroyMutationError = void
    export type AttachmentsDestroyMutationVariables = {id: string}

    export const useAttachmentsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachmentsDestroy>>, TError,AttachmentsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof attachmentsDestroy>>,
        TError,
        AttachmentsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAttachmentsDestroyMutationOptions(options), queryClient);
    }
    export const getAttachmentsCloudinaryCallbackCreateUrl = () => {




  return `/api/attachments/cloudinary-callback/`
}

/**
 * Endpoint for Cloudinary to notify us about uploaded attachment image moderation status
 */
export const attachmentsCloudinaryCallbackCreate = async ( options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getAttachmentsCloudinaryCallbackCreateUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAttachmentsCloudinaryCallbackCreateMutationKey = () => ['attachmentsCloudinaryCallbackCreate'] as const;

export const getAttachmentsCloudinaryCallbackCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachmentsCloudinaryCallbackCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof attachmentsCloudinaryCallbackCreate>>, TError,void, TContext> => {

const mutationKey = getAttachmentsCloudinaryCallbackCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof attachmentsCloudinaryCallbackCreate>>, void> = () => {


          return  attachmentsCloudinaryCallbackCreate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AttachmentsCloudinaryCallbackCreateMutationResult = NonNullable<Awaited<ReturnType<typeof attachmentsCloudinaryCallbackCreate>>>

    export type AttachmentsCloudinaryCallbackCreateMutationError = void


    export const useAttachmentsCloudinaryCallbackCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachmentsCloudinaryCallbackCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof attachmentsCloudinaryCallbackCreate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAttachmentsCloudinaryCallbackCreateMutationOptions(options), queryClient);
    }
    export const getAttachmentsUploadCreateUrl = () => {




  return `/api/attachments/upload/`
}

/**
 * Endpoint to upload a file as an attachment in our system. At most 10MB file is allowed.
 */
export const attachmentsUploadCreate = async (attachmentUploadRequestRequest: AttachmentUploadRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<Attachment> => {
    const formData = new FormData();
formData.append(`file`, attachmentUploadRequestRequest.file);
formData.append(`provider`, attachmentUploadRequestRequest.provider);
if(attachmentUploadRequestRequest.name !== undefined) {
 formData.append(`name`, attachmentUploadRequestRequest.name);
 }

  return customFetch<Attachment>(getAttachmentsUploadCreateUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getAttachmentsUploadCreateMutationKey = () => ['attachmentsUploadCreate'] as const;

export const getAttachmentsUploadCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachmentsUploadCreate>>, TError,AttachmentsUploadCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof attachmentsUploadCreate>>, TError,AttachmentsUploadCreateMutationVariables, TContext> => {

const mutationKey = getAttachmentsUploadCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof attachmentsUploadCreate>>, AttachmentsUploadCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  attachmentsUploadCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AttachmentsUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof attachmentsUploadCreate>>>
    export type AttachmentsUploadCreateMutationBody = AttachmentUploadRequestRequest
    export type AttachmentsUploadCreateMutationError = void
    export type AttachmentsUploadCreateMutationVariables = {data: AttachmentUploadRequestRequest}

    export const useAttachmentsUploadCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachmentsUploadCreate>>, TError,AttachmentsUploadCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof attachmentsUploadCreate>>,
        TError,
        AttachmentsUploadCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAttachmentsUploadCreateMutationOptions(options), queryClient);
    }
